import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';

import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ProcessService extends BaseProvider {
	itemToEdit: any = {};
	processTypes: any = [];
	categories: any = {};
	filteredCategories: any = {};
	parentCategories: any = [];
	childCategories: any = [];
	selectedCategory: any;
	selectedCategoryId: any;
	constructor(
		public globals: GlobalsService,
		public http: HttpClient,
		public ls: LsHelperService,
	) {
		super();

		this.baseUrl = "processType";
	}

	searchProcessTypesByTerm(params: any) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
			'/searchTerm/' + params.term +
			'/page/' + params.pageNumber +
			'/size/' + params.pageSize;

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						this.processTypes = data.Data;

						resolve(data.Data);
					},
					err => { reject(err) }
				);
		});
	}

	searchByCategoryAndTerm(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/category/' + params.categoryId +
				'/searchTerm/' + params.term;

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						resolve(this.setupCategoryTypes(data.Data));
					},
					err => { reject(err) }
				);
		});
	}

	setupCategoryTypes(data) {
		var parentCategories = data.ParenteCategories;
		var childCategories = data.ChildCategories;
		var processTypes = data.ProcessTypes;
		parentCategories.forEach((parentCategory) => {
			parentCategory.processTypes = [];
			parentCategory.childCategories = [];

			data.ProcessTypes.forEach((processType) => {
				if (processType.CategoryId == parentCategory.Id) {
					parentCategory.processTypes.push(processType);
				}
			});

			data.ChildCategories.forEach((childCategory) => {
				var newChildCategory: any = {};

				Object.assign(newChildCategory, childCategory);

				newChildCategory.processTypes = [];

				if (newChildCategory.ParentCategoryId == parentCategory.Id) {
					data.ProcessTypes.forEach((processType) => {
						if (processType.CategoryId == newChildCategory.Id) {
							newChildCategory.processTypes.push(processType);
						}
					});

					parentCategory.childCategories.push(newChildCategory);
				}
			});
		});

		// if(parentCategories.length == 0 && processTypes.length > 0){
		// 	parentCategories.CategoryDescription = processTypes[0].CategoryDescriptionParent;
		// 	parentCategories.CategoryLabel = processTypes[0].CategoryLabelParent;
		// 	parentCategories.FileName = processTypes[0].FileNameParent;
		// 	parentCategories.OrderIndex = processTypes[0].OrderIndexParent;
		// 	parentCategories.ParentCategoryId = processTypes[0].ParentCategoryIdParent;
		// 	parentCategories.processTypes = processTypes
		// }




		return parentCategories;
	}

	getAllCategories() {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/categories';

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						this.categories = data.Data;

						resolve(data.Data);
					},
					err => { reject(err) }
				);
		});
	}

	getLookups() {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/lookup';

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						this.lookups = data.Data;

						resolve(data.Data);
					},
					err => { reject(err) }
				);
		});
	}

	getProcess(id) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/' + id

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						this.itemToEdit = data.Data;

						resolve(data);
					},
					err => { reject(err) }
				);
		});
	}

	getProcessTypes(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/search/page/' + params.pageNumber +
				'/size/' + params.pageSize +
				'?term=' + params.term;

			this.http.get(
				this.url
			)
				.subscribe(
					(data: any) => {
						resolve(data);
					},
					err => { reject(err) }
				);
		});
	}

	create(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl;

			this.http
				.post(
					this.url,
					params
				)
				.subscribe(
					(data: any) => {
						resolve(data.Data)
					},
					err => { reject(err) }
				);
		});
	}

	update(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + "/" + params.Id;

			this.http
				.put(this.url, params)
				.subscribe(
					(data: any) => {
						this.itemToEdit = (params);
						resolve(data);
					},
					err => { reject(err) }
				);
		});
	}

	delete(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + "/" + params.id;

			this.http
				.delete(
					this.url
				)
				.subscribe(
					(data: any) => {
						resolve(data);
					},
					err => { reject(err) }
				);
		});
	}
}
